import React from "react";
import "./CustomSwitch.css";
const ResupplySwitch = ({ value, onChange, disabled = false }) => {
  return (
    <div>
      <label className={`switch ${disabled ? "switch-disabled" : ""}`}>
        <input
          type="checkbox"
          onFocus={(e) => e.target.blur()} //
          disabled={disabled}
          checked={value}
          onChange={(e) => onChange(e.target.checked)}
        />
        <span className="slider round"></span>
      </label>
    </div>
  );
};

export default React.memo(ResupplySwitch);
